<div class="toast-container">
    <fa-icon *ngIf="data.icon" [icon]="['tg', data.icon]" class="toast-icon"></fa-icon>
    <span class="toast-text">{{ data.text }}</span>
</div>
